import React from 'react';

export default function Status(props) {
    return (
        <div id="status">{props.value}</div>
    );
}
